import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function () {
  // para cada bloco na página
  document.querySelectorAll('.workshop-grid-background').forEach((wrapper) => {
    // pode haver 2 swipers (desktop e mobile)
    const swiperEls = wrapper.querySelectorAll('.mySwiper');
    if (!swiperEls.length) return;

    const instances = [];

    swiperEls.forEach((swiperEl) => {
      if (!isVisible(swiperEl)) return; // só inicializa o visível

      const nextEl     = closestInWrapper(swiperEl, wrapper, '.custom-arrow.swiper-button-next');
      const prevEl     = closestInWrapper(swiperEl, wrapper, '.custom-arrow.swiper-button-prev');
      const pagination = closestInWrapper(swiperEl, wrapper, '.swiper-pagination');

      const isMobile = window.innerWidth < 960;

      const inst = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: isMobile, // loop apenas em mobile
        autoHeight: isMobile,
        autoplay: { delay: 2500, disableOnInteraction: false },
        navigation: { nextEl, prevEl },
        pagination: { el: pagination, clickable: true },
        breakpoints: { 960: { slidesPerView: 2.4, spaceBetween: 24 } },
        on: {
          init() {
            syncSlideVideos(this);
            updateMobileMode(wrapper, this);
            requestAnimationFrame(() => {
              updateBackgroundForWrapper(wrapper);
              applyAdaptiveClamps(wrapper);
            });
          },
          slideChange() {
            syncSlideVideos(this);
            updateMobileMode(wrapper, this);
            requestAnimationFrame(() => {
              updateBackgroundForWrapper(wrapper);
              applyAdaptiveClamps(wrapper);
            });
          },
          resize() {
            updateMobileMode(wrapper, this);
            requestAnimationFrame(() => {
              updateBackgroundForWrapper(wrapper);
              applyAdaptiveClamps(wrapper);
            });
          },
        },
      });

      // guarda para atualizações futuras
      swiperEl._wgSwiper = inst;
      instances.push(inst);
    });

    // se o utilizador muda o tamanho (breakpoint alterna desktop/mobile),
    // garantimos que a instância correta existe e está atualizada
    const onViewportChange = () => {
      // (re)inicializa instâncias que não existam e estejam visíveis
      wrapper.querySelectorAll('.mySwiper').forEach((el) => {
        if (isVisible(el) && !el._wgSwiper) {
          const nextEl     = closestInWrapper(el, wrapper, '.custom-arrow.swiper-button-next');
          const prevEl     = closestInWrapper(el, wrapper, '.custom-arrow.swiper-button-prev');
          const pagination = closestInWrapper(el, wrapper, '.swiper-pagination');
          const isMobile   = window.innerWidth < 960;

          const inst = new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: isMobile,
            autoHeight: isMobile,
            autoplay: { delay: 2500, disableOnInteraction: false },
            navigation: { nextEl, prevEl },
            pagination: { el: pagination, clickable: true },
            breakpoints: { 960: { slidesPerView: 2.4, spaceBetween: 24 } },
          });
          el._wgSwiper = inst;
          instances.push(inst);
        }
      });

      // atualiza todas as instâncias existentes + modo mobile
      instances.forEach((s) => {
        if (s && s.update) s.update();
        updateMobileMode(wrapper, s);
      });

      requestAnimationFrame(() => {
        updateBackgroundForWrapper(wrapper);
        applyAdaptiveClamps(wrapper);
      });
    };

    // media carregados podem alterar altura → atualizar
    wrapper.querySelectorAll('img, video').forEach((m) => {
      if (!m.complete) {
        m.addEventListener('load', () =>
          requestAnimationFrame(() => {
            updateBackgroundForWrapper(wrapper);
            applyAdaptiveClamps(wrapper);
          }),
        { once: true });

        m.addEventListener('loadedmetadata', () =>
          requestAnimationFrame(() => {
            updateBackgroundForWrapper(wrapper);
            applyAdaptiveClamps(wrapper);
          }),
        { once: true });
      }
    });

    // recalc em eventos de janela
    ['load', 'resize', 'scroll'].forEach((ev) => {
      window.addEventListener(ev, () =>
        requestAnimationFrame(onViewportChange),
      { passive: true });
    });

    // quando as fontes web terminam de carregar (pode alterar alturas)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() =>
        requestAnimationFrame(onViewportChange)
      );
    }

    // observar mudanças internas (e.g., alternância only-desktop/only-mobile)
    const mo = new MutationObserver(() => {
      requestAnimationFrame(onViewportChange);
    });
    mo.observe(wrapper, { childList: true, subtree: true });

    // primeira medição
    onViewportChange();
  });

  // Observers + primeira medição do gradiente por wrapper
  initBackgroundAdjustment();
});

/* ======== Helpers ======== */

// encontra o selector mais próximo dentro do mesmo wrapper
function closestInWrapper(fromEl, wrapper, selector) {
  const local = fromEl.parentElement?.querySelector(selector);
  if (local) return local;
  return wrapper.querySelector(selector);
}

// elemento está visível (não display:none, tem caixa renderizada)
function isVisible(el) {
  const style = window.getComputedStyle(el);
  if (style.display === 'none') return false;
  if (!el.getClientRects().length) return false;
  return true;
}

// devolve o .mySwiper visível dentro do wrapper
function getVisibleSwiper(wrapper) {
  const swipers = Array.from(wrapper.querySelectorAll('.mySwiper'));
  return swipers.find(isVisible) || null;
}

// Reproduz apenas o vídeo do slide ativo
function syncSlideVideos(swiper) {
  if (!swiper || swiper.destroyed || !swiper.slides) return;
  swiper.slides.forEach((slide, idx) => {
    const video = slide.querySelector('video');
    if (!video) return;
    if (idx === swiper.activeIndex) {
      video.muted = true;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } else {
      video.pause();
      video.currentTime = 0;
    }
  });
}

/**
 * Alterna classes no wrapper para estilos diferentes em mobile:
 * - is-highlight-slide: 1.º slide (workshop)
 * - is-post-slide:      restantes
 * Usa realIndex (estável com loop).
 */
function updateMobileMode(wrapper, swiper) {
  if (!swiper) return;
  const isMobile = window.innerWidth < 960;
  if (!isMobile) {
    wrapper.classList.remove('is-highlight-slide', 'is-post-slide');
    return;
  }
  const idx = typeof swiper.realIndex === 'number' ? swiper.realIndex : (swiper.activeIndex || 0);
  const isFirst = idx === 0;
  wrapper.classList.toggle('is-highlight-slide', isFirst);
  wrapper.classList.toggle('is-post-slide', !isFirst);
}

/**
 * Atualiza o gradiente com base NO SLIDE ATIVO VISÍVEL (ou fallback seguro).
 * - Desktop: topo da .overlay.feat do destaque.
 * - Mobile:
 *    * Slide 0 (featured): fundo do media (ou topo da overlay.feat se absoluta)
 *    * Demais slides (posts): topo da .overlay.sp (logo abaixo da imagem)
 * Usa coordenadas de página (scrollY) para estabilidade.
 */
function updateBackgroundForWrapper(bg) {
  const isMobile = window.innerWidth < 960;
  const bgTop = bg.getBoundingClientRect().top + window.scrollY;

  let cutY = null;

  if (isMobile) {
    const visibleSwiper = getVisibleSwiper(bg);
    const active = visibleSwiper
      ? visibleSwiper.querySelector('.swiper-slide-active')
      : null;

    if (active && active.getClientRects().length) {
      const card = active.querySelector('.post-card');
      if (card) {
        const media    = card.querySelector('video, img.post-thumbnail');
        const overlayF = card.querySelector('.overlay.feat');
        const overlayP = card.querySelector('.overlay.sp');

        if (card.classList.contains('featured')) {
          // 1º slide: fim do media, ou topo da overlay se absoluta
          if (overlayF && getComputedStyle(overlayF).position === 'absolute') {
            const r = overlayF.getBoundingClientRect();
            cutY = (r.top + window.scrollY) - bgTop;
          } else if (media && media.getClientRects().length) {
            const r = media.getBoundingClientRect();
            cutY = (r.bottom + window.scrollY) - bgTop;
          }
        } else {
          // posts: topo da overlay.sp (ou fim do media se necessário)
          if (overlayP && overlayP.getClientRects().length) {
            const r = overlayP.getBoundingClientRect();
            cutY = (r.top + window.scrollY) - bgTop;
          } else if (media && media.getClientRects().length) {
            const r = media.getBoundingClientRect();
            cutY = (r.bottom + window.scrollY) - bgTop;
          }
        }
      }
    }
  }

  // Desktop OU fallback (se algo falhou em mobile)
  if (cutY == null) {
    const feat = bg.querySelector('.post-card.featured');
    if (feat) {
      const overlay = feat.querySelector('.overlay.feat');
      if (overlay && overlay.getClientRects().length) {
        const r = overlay.getBoundingClientRect();
        cutY = (r.top + window.scrollY) - bgTop;
      } else {
        // fallback adicional: centro do destaque
        const fr = feat.getBoundingClientRect();
        cutY = (fr.top + fr.height / 2 + window.scrollY) - bgTop;
      }
    }
  }

  if (cutY == null || !isFinite(cutY)) {
    // último recurso: metade do wrapper
    cutY = bg.clientHeight / 2;
  }

  const max = Math.max(bg.clientHeight, 1);
  if (cutY < 0) cutY = 0;
  else if (cutY > max) cutY = max;

  bg.style.background =
    `linear-gradient(to bottom, #1142d4 0, #1142d4 ${Math.round(cutY)}px, #172B43 ${Math.round(cutY)}px, #172B43 100%)`;
}

// Observa redimensionamentos relevantes e faz a 1ª medição em cada bloco
function initBackgroundAdjustment() {
  const wrappers = document.querySelectorAll('.workshop-grid-background');
  if (!wrappers.length) return;

  wrappers.forEach((bg) => {
    const roBg = new ResizeObserver(() =>
      requestAnimationFrame(() => {
        updateBackgroundForWrapper(bg);
        applyAdaptiveClamps(bg);
      })
    );
    roBg.observe(bg);

    let lastObserved = null;
    const roCard = new ResizeObserver(() =>
      requestAnimationFrame(() => {
        updateBackgroundForWrapper(bg);
        applyAdaptiveClamps(bg);
      })
    );
    const roMisc = new ResizeObserver(() =>
      requestAnimationFrame(() => {
        updateBackgroundForWrapper(bg);
        applyAdaptiveClamps(bg);
      })
    );

    const tryObserveTarget = () => {
      // em mobile, observar o slide ativo visível; em desktop, observar o destaque
      const target = window.innerWidth < 960
        ? (getVisibleSwiper(bg)?.querySelector('.swiper-slide-active .post-card') || null)
        : bg.querySelector('.post-card.featured');

      if (target && target !== lastObserved) {
        if (lastObserved) roCard.unobserve(lastObserved);
        roCard.observe(target);

        const overlay = target.querySelector('.overlay.feat, .overlay.sp');
        const media = target.querySelector('video, img.post-thumbnail');
        if (overlay) roMisc.observe(overlay);
        if (media) roMisc.observe(media);

        lastObserved = target;
      }
    };

    tryObserveTarget();

    const mo = new MutationObserver(() => {
      tryObserveTarget();
      requestAnimationFrame(() => {
        updateBackgroundForWrapper(bg);
        applyAdaptiveClamps(bg);
      });
    });
    mo.observe(bg, { childList: true, subtree: true });

    updateBackgroundForWrapper(bg);
    applyAdaptiveClamps(bg);
  });
}

/* ======== Adaptive clamp (novo) ======== */

/**
 * Tenta aplicar o clamp máximo e, se ainda houver overflow,
 * vai reduzindo (ex.: 5 -> 4 -> 3) até caber.
 * @param {HTMLElement} el
 * @param {number} maxLines
 * @param {number} minLines
 */
function clampToFit(el, maxLines, minLines = 2) {
  if (!el) return;
  el.style.display = '-webkit-box';
  el.style.webkitBoxOrient = 'vertical';

  let lines = maxLines;
  el.style.webkitLineClamp = String(lines);
  // força reflow
  // eslint-disable-next-line no-unused-expressions
  el.offsetHeight;

  while (lines > minLines && el.scrollHeight > el.clientHeight + 1) {
    lines -= 1;
    el.style.webkitLineClamp = String(lines);
    // eslint-disable-next-line no-unused-expressions
    el.offsetHeight;
  }
}

/**
 * Aplica clamp adaptativo ao destaque e ao slide ativo visível.
 */
function applyAdaptiveClamps(wrapper) {
  if (!wrapper) return;

  // Destaque (desktop)
  const feat = wrapper.querySelector('.only-desktop .post-card.featured .overlay.feat');
  if (feat) {
    let featP = feat.querySelector('.ex-t');
    if (!featP) {
      featP = Array.from(feat.querySelectorAll('p')).find(p => p.textContent.trim().length > 0) || null;
    }
    if (featP) {
      // tenta 5 linhas; reduz até 3 se necessário
      clampToFit(featP, 5, 3);
    }
  }

  // Slide ativo (cards)
  const visibleSwiper = getVisibleSwiper(wrapper);
  const active = visibleSwiper ? visibleSwiper.querySelector('.swiper-slide-active') : null;
  if (active) {
    const cardP = active.querySelector('.overlay.sp .wr-sp > p:not(:empty)') ||
                  active.querySelector('.overlay.sp .wr-sp p');
    if (cardP) {
      // tenta 3 linhas; reduz até 2 se necessário
      clampToFit(cardP, 3, 2);
    }
  }
}
